import validator from "validator"

export const isValidPhone = (phone: string) => {
  return validator.isMobilePhone(phone)
}

export const isInvalidPhone = (phone: string) => {
  return !isValidPhone(phone)
}

export const isValidName = (name: string) => {
  name = name.trim()
  return !validator.isEmpty(name) && isAlphaOrSpace(name)
}

export const isInvalidName = (name: string) => {
  return !isValidName(name)
}

export const isNumeric = (name: string) => {
  return validator.matches(name, /^[0-9]*$/)
}

export const isAlphaOrSpace = (name: string) => {
  return validator.matches(name, /^[a-zA-Z ]*$/)
}
